import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { IconButton, Tooltip } from '@mui/material';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import ConfirmDialog from '../../Dialog/ConfirmDialog';

/**
 * Deletes the saved layout being edited, once the deletion is confirmed.
 *
 * @param {Object} props - Component props.
 * @param {Boolean} props.disabled - Whether there is no saved layout to delete.
 * @param {String} props.name - The layout's name, as the confirmation names it.
 * @param {Function} props.onDelete - Called once the deletion is confirmed.
 *
 * @returns {React.JSX.Element}
 */
const DeleteLayoutButton = function DeleteLayoutButton({
  disabled = false,
  name = '',
  onDelete = () => {},
}) {
  const intl = useIntl();
  const [confirming, setConfirming] = useState(false);

  return (
    <>
      <Tooltip arrow title={intl.messages.DELETE_LAYOUT}>
        <span>
          <IconButton
            id="delete-layout-btn"
            disabled={disabled}
            onClick={() => setConfirming(true)}
          >
            <DeleteForeverRoundedIcon />
          </IconButton>
        </span>
      </Tooltip>
      <ConfirmDialog
        open={confirming}
        title="DELETE_LAYOUT"
        question={`${intl.messages.DELETE_LAYOUT_QUESTION} — ${name}`}
        confirmLabel="DELETE"
        onCancel={() => setConfirming(false)}
        onSubmit={() => {
          setConfirming(false);
          onDelete();
        }}
      />
    </>
  );
};

export default DeleteLayoutButton;
